import type { WorkItem } from "./useDailySummaryQuery";

export interface WorkHistoryContractorGroup {
  contractor_id: number;
  contractor_name: string;
  trades: WorkItem[];
}

/**
 * 업체별로 묶는다. 이름이 같은 다른 업체가 있을 수 있으므로 contractor_id로 구분한다
 * (contractor_name으로 묶으면 서로 다른 업체가 합쳐질 수 있다).
 */
export function groupWorkItemsByContractor(items: WorkItem[]): WorkHistoryContractorGroup[] {
  const map = new Map<number, WorkHistoryContractorGroup>();
  for (const item of items) {
    const existing = map.get(item.contractor_id);
    if (existing) {
      existing.trades.push(item);
    } else {
      map.set(item.contractor_id, {
        contractor_id: item.contractor_id,
        contractor_name: item.contractor_name,
        trades: [item],
      });
    }
  }
  return Array.from(map.values());
}
